import type { AuthenticatedUser } from '../Services/IAuthService';
import type { AuthContextValue } from '../Components/Auth/AuthProvider';
import { useAuthProvider } from '../Components/Auth/AuthProvider';

export type UseAuthenticatedUser<T extends AuthenticatedUser = AuthenticatedUser> = Pick<
	AuthContextValue,
	'isLoading' | 'isInitialLoading'
> & {
	user: T | null;
};

export default function useAuthenticatedUser<
	T extends AuthenticatedUser = AuthenticatedUser,
>(): UseAuthenticatedUser<T> {
	const authContext = useAuthProvider();

	return {
		user: (authContext?.user as T) ?? null,
		isLoading: authContext?.isLoading ?? false,
		isInitialLoading: authContext?.isInitialLoading ?? false,
	};
}
